'use client';

import type { SortingState } from '@tanstack/react-table';
import { useState } from 'react';

export function useTableSort() {
  const [sorting, setSorting] = useState<SortingState>([]);

  return {
    sorting,
    setSorting,
  };
}
